"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var APITokenManager_1 = __importDefault(require("@/Domains/API/APITokenManager"));
var AppLayout_1 = __importDefault(require("@/Layouts/AppLayout"));
function ApiTokenIndex(_a) {
    var tokens = _a.tokens, availablePermissions = _a.availablePermissions, defaultPermissions = _a.defaultPermissions;
    return (react_1.default.createElement(AppLayout_1.default, { title: 'API Tokens' },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "mx-auto py-10 sm:px-6 lg:px-8" },
                react_1.default.createElement(APITokenManager_1.default, { tokens: tokens, availablePermissions: availablePermissions, defaultPermissions: defaultPermissions })))));
}
exports.default = ApiTokenIndex;
